import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const ToastProviderInstanceContext = /*#__PURE__*/createContext(false);
const ToastContext = /*#__PURE__*/createContext();
export const useToast = () => useContext(ToastContext);
const TOAST_LIMIT = 5;
let toastIdCounter = 0;
export const ToastProvider = _ref => {
  let {
    children
  } = _ref;
  const instanceExists = useContext(ToastProviderInstanceContext);
  const [toasts, setToasts] = useState([]);
  if (instanceExists) {
    throw new Error("Multiple instances of ToastProvider detected. Only one instance is allowed.");
  }
  const addToast = useCallback(_ref2 => {
    let {
      message,
      type,
      dataTestId = "toast",
      autoClose = 5000,
      className = "",
      preventCloseOnHover = false,
      preventAutoClose = false
    } = _ref2;
    if (!message || !type) {
      console.error("Both message and type are required to show a toast.");
      return;
    }
    const id = ++toastIdCounter;
    setToasts(prevToasts => {
      const updatedToasts = [...prevToasts, {
        id,
        message,
        type,
        dataTestId,
        autoClose,
        className,
        preventCloseOnHover,
        preventAutoClose
      }];
      if (updatedToasts.length > TOAST_LIMIT) {
        updatedToasts.shift();
      }
      return updatedToasts;
    });
  }, []);
  const removeToast = useCallback(id => {
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
  }, []);
  const contextValue = useMemo(() => ({
    toasts,
    addToast,
    removeToast
  }), [toasts, addToast, removeToast]);
  return /*#__PURE__*/_jsx(ToastProviderInstanceContext.Provider, {
    value: true,
    children: /*#__PURE__*/_jsx(ToastContext.Provider, {
      value: contextValue,
      children: children
    })
  });
};
//# sourceMappingURL=ToastProvider.js.map